module.exports = __webpack_public_path__ + "assets/img/noCaptch-light-en.4af48e2d.png";